export default __webpack_public_path__ + "static/media/Flourish.a28b305e.png";